// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1e00O","content":"LoadingAlert_content__uy6EX"};